import { render, staticRenderFns } from "./table-top-handler.vue?vue&type=template&id=0c9305ad&scoped=true&"
import script from "./table-top-handler.vue?vue&type=script&lang=js&"
export * from "./table-top-handler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9305ad",
  null
  
)

export default component.exports